<template>
  <div class="tm-help-icon-tooltip">
    <tm-icon
      :name="icon"
      :size="iconSize"
      :class="iconClass"
    />
    <tm-tooltip
      :white="white"
      :max-width="maxWidth"
      :position="position"
      :content-class="tooltipContentClass"
    >
      <div class="lh-20 body-text-regular-14">
        <slot>{{ tooltip }}</slot>
      </div>
    </tm-tooltip>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from '@/composition/vue/compositionApi'
import TmIcon, { tmIconProps } from '@/components/shared/TmIcon.vue'
import TmTooltip from '@/components/shared/tooltip/TmTooltip.vue'
import type { ControlPosition } from '@/composition/tooltip/renderTooltip'
import { VueLikeClassProp } from '@/components/types'
import type { IconName } from '@/assets/icons/icons'
import type { StylesheetSizeProp } from '@/types'

defineProps({
  tooltip: {
    type: String,
    default: '',
  },
  maxWidth: {
    type: String as PropType<StylesheetSizeProp>,
  },
  icon: {
    type: String as PropType<IconName>,
    default: 'tmi-help' satisfies IconName,
  },
  white: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String as PropType<ControlPosition>,
  },
  iconSize: tmIconProps.size,
  tooltipContentClass: {
    type: VueLikeClassProp,
    default: 'text-center',
  },
  iconClass: VueLikeClassProp,
})
</script>

<style lang="scss" scoped>
.tm-help-icon-tooltip {
  display: flex;
  align-items: center;
  color: $gray5;
  margin-left: 4px;
}
</style>
